module.exports = __webpack_public_path__ + "img/kausima_image2.a770dcef.jpg";